(function (global) {
  "use strict";

  global.PRODUCT_SELECTION_PRODUCTS = [
    {
      image: "Jetson/NexArm%20ROS.png",
      name: "NexArm ROS",
      link: "https://detail.tmall.com/item.htm?abbucket=4&id=1054432686379&mi_id=0000LRcplcUtoMdzhYlR5TPMPiRcWbJguQ4aq2H6Tz05Xbw&ns=1&priceTId=2150454c17854002760102379e1809&skuId=6095158476178&spm=a21n57.1.hoverItem.2&utparam=%7B%22aplus_abtest%22%3A%22544d0ccdc65f6c7e7139815d8d85dd70%22%7D&xxc=taobaoSearch",
      platform: ["jetson"],
      type: ["arm"],
    },
    {
      image: "AI&ROS/ROSPug_.png",
      name: "ROSPug",
      link: "https://item.jd.com/10194447112692.html?pcdk=7gnwFTgZvaRhEii1aCnba43xdwL4AbxIBHXgHt5fbc4=.M8AW.sbc1",
      platform: ["ros", "jetson"],
      type: ["quadruped"],
    },
    {
      image: "AI&ROS/ROSpider_.png",
      name: "ROSpider",
      link: "https://item.jd.com/10149449932278.html?pcdk=3LeRlcsSF4cDiY_YBv1C26QixNsUHZXoMU7-Ov5VkBg=.M8AW.sbc1",
      platform: ["ros"],
      type: ["hexapod"],
    },
    // {
    //   image: "AI&ROS/Rostony_.png",
    //   name: "Rostony",
    //   link: "#",
    //   platform: ["ros"],
    //   type: ["humanoid"],
    // },
    {
      image: "725/TurboPi_.png",
      name: "TurboPi",
      link: "https://item.taobao.com/item.htm?ali_refid=a3_430582_1006%3A1104166432%3AN%3A9MiLkKuuADZ5QnogpR5zmt%2FvfALSx%2F%2F2%3A163acf59cbfbc009ba68ec40b6d8ecc8&ali_trackid=199_163acf59cbfbc009ba68ec40b6d8ecc8&id=698668065022&mi_id=0000A39uqPH119bRiI-k26icemRVnXYAYcMJA9oczcKFJi4&mm_sceneid=5_1_29997538_0&priceTId=2150452817849717091341195e0f15&skuId=5762142577353&spm=a21n57.1.hoverItem.1&utparam=%7B%22aplus_abtest%22%3A%22c92324e89c8c4a6286510fe743df8f60%22%7D&xxc=ad_ztc",
      platform: ["ros", "raspberry"],
      type: ["car"],
    },
    {
      image: "https://store.hiwonder.com.cn/uploads/20260928/FplzGy3pvzD-iR_R5E5oDSEe0aKn/1-2000x2000_451fab33-f6cf-40d9-bb4e-bf74527ea11d.png",
      name: "ClawPi",
      handle: "clawpi-ros2",
      platform: ["raspberry"],
      type: ["car"],
    },
    // {
    //   image: "Raspberry%20Pi/AiNex_.png",
    //   name: "AiNex",
    //   link: "https://item.jd.com/10144717125987.html?pcdk=Z49FmJGeHSrK5oSWl45OomFA5QBLpvkTvmG_1YxiPQM=.M8AW.sbc1",
    //   platform: ["raspberry"],
    //   type: ["humanoid"],
    // },
    {
      image: "Raspberry%20Pi/ArmPi%20FPV.png",
      name: "ArmPi FPV",
      link: "https://item.jd.com/10099286192859.html?pcdk=qQojJ3QrUnZFBC5j2Sx-5FuDOMAdoavm66Qt8uzthdQ=.M8AW.sbc1",
      platform: ["raspberry", "ros"],
      type: ["arm"],
    },
    {
      image: "Raspberry%20Pi/ArmPi%20Pro_.png",
      name: "ArmPi Pro",
      link: "https://item.jd.com/10164102384992.html?pcdk=kCOV9VTEhGxBxOT5GHa8TID0YeoLTcTsC90mKsYzvM0=.M8AW.sbc1",
      platform: ["raspberry"],
      type: ["composite"],
    },
    {
      image: "Raspberry%20Pi/ArmPi%20Ultra_.png",
      name: "ArmPi Ultra",
      link: "https://item.jd.com/10214552917019.html?pcdk=O027Rav8bUTDy0-1DXTMgvu6jizjVCI1jbsiMpVtn0Q=.M8AW.sbc1",
      platform: ["raspberry", "ros"],
      type: ["arm"],
    },
    // {
    //   image: "Raspberry%20Pi/ArmPi%20mini_.png",
    //   name: "ArmPi mini",
    //   link: "https://item.jd.com/10163102431185.html?pcdk=OyhaPuKDJXzUjUjqyRLj44mzrt-rSXnTjPuvS49gmVE=.M8AW.sbc1",
    //   platform: ["raspberry"],
    //   type: ["arm"],
    // },
    {
      image: "Raspberry%20Pi/GoGoPi_.png",
      name: "GoGoPi",
      link: "https://item.jd.com/10099278525487.html?pcdk=Ewz6GSSqHstQVkhQ5wXKwod-Z_Lnq41ZKpaML9SrJCM=.M8AW.sbc1",
      platform: ["raspberry"],
      type: ["car"],
    },
    {
      image: "Raspberry%20Pi/LanderPi.png",
      name: "LanderPi",
      link: "https://item.jd.com/10214549062413.html?pcdk=x0g7JJuWp98XM3CSBqmKC1ls9YYySy8Mka1tT8tuXto=.M8AW.sbc1",
      platform: ["raspberry", "ros"],
      type: ["composite"],
    },
    {
      image: "Raspberry%20Pi/LanderPi_%E5%B1%A5%E5%B8%A6%E5%BA%95%E7%9B%98.png",
      name: "LanderPi Tracked Chassis",
      link: "https://item.jd.com/10214549062419.html?pcdk=Rl1m0zbBm8HbAGLwPDAEJcDBqa-yJs0FC2XBiArKAW4=.M8AW.sbc1",
      platform: ["raspberry"],
      type: ["car"],
    },
    {
      image: "Raspberry%20Pi/MasterPi_.png",
      name: "MasterPi",
      link: "https://mall.jd.com/view_search-1458753-10207769-10071677-0-1-0-0-1-1-24.html?keyword=MasterPi&isGlobalSearch=1",
      platform: ["raspberry"],
      type: ["composite"],
    },
    // {
    //   image: "Raspberry%20Pi/MentorPi%20A1_.png",
    //   name: "MentorPi A1",
    //   link: "https://item.jd.com/10214546872500.html?pcdk=4C1zyx1QZRdoi5OfZkThdug2X0QPhQaxm9U6zNUsW3Q=.M8AW.sbc1",
    //   platform: ["raspberry"],
    //   type: ["car"],
    // },
    // {
    //   image: "Raspberry%20Pi/MentorPi%20M1__.png",
    //   name: "MentorPi M1",
    //   link: "https://item.jd.com/10214546872500.html?pcdk=4C1zyx1QZRdoi5OfZkThdug2X0QPhQaxm9U6zNUsW3Q=.M8AW.sbc1",
    //   platform: ["raspberry"],
    //   type: ["car"],
    // },
    // {
    //   image: "Raspberry%20Pi/MentorPi%20Ti_.png",
    //   name: "MentorPi Ti",
    //   link: "https://item.jd.com/10214546872500.html?pcdk=4C1zyx1QZRdoi5OfZkThdug2X0QPhQaxm9U6zNUsW3Q=.M8AW.sbc1",
    //   platform: ["raspberry"],
    //   type: ["car"],
    // },
    {
      image: "728/uHandPi.png",
      name: "uHandPi",
      link: "https://item.jd.com/10099283972473.html?pcdk=H3IDZnJtT7g3fhVUa15fngEZpEOnrGNgCM__rgjsRjY=.M8AW.sbc1",
      platform: ["raspberry"],
      type: ["gripper"],
    },
    {
      image: "Raspberry%20Pi/MentorPi%20Ti_.png",
      name: "MentorPi T1",
      link: "https://item.jd.com/10214546872500.html?pcdk=4C1zyx1QZRdoi5OfZkThdug2X0QPhQaxm9U6zNUsW3Q=.M8AW.sbc1",
      platform: ["raspberry"],
      type: ["car"],
    },

    {
      image: "Raspberry%20Pi/MentorPi_.png",
      name: "MentorPi",
      link: "https://item.jd.com/10214546872500.html?pcdk=4C1zyx1QZRdoi5OfZkThdug2X0QPhQaxm9U6zNUsW3Q=.M8AW.sbc1",
      platform: ["raspberry", "ros"],
      type: ["car"],
    },
    {
      image: "Raspberry%20Pi/MentorPi%20A1%20Depth%20Camera_.png",
      name: "MentorPi A1",
      link: "https://item.jd.com/10214546872500.html?pcdk=4C1zyx1QZRdoi5OfZkThdug2X0QPhQaxm9U6zNUsW3Q=.M8AW.sbc1",
      platform: ["ros", "raspberry"],
      type: ["composite", "car"],
    },
    {
      image: "ESP32%20&%20Arduino/1030/PuppyPi_.png",
      name: "PuppyPi",
      link: "https://item.jd.com/10138714905696.html?pcdk=eVXVTIJzSlEIfkGVH-lvqrY5B_d1oS3k7924Um8AyXk=.M8AW.sbc1",
      platform: ["raspberry", "ros"],
      type: ["quadruped"],
    },
    {
      image: "Raspberry%20Pi/SpiderPi_.png",
      name: "SpiderPi",
      link: "https://item.jd.com/10106318408120.html?pcdk=py6tx39bSWN1ebzIVWhUEdmtsvNy44CdRxIn088VVHY=.M8AW.sbc1",
      platform: ["raspberry"],
      type: ["hexapod"],
    },
    {
      image: "Raspberry%20Pi/SpiderPi%20Pro_.png",
      name: "SpiderPi Pro",
      link: "https://item.jd.com/10106313774851.html?pcdk=jSgX_QdlyBmAagF1l01Xrv2O7SI7IHURdaHcG_6grdU=.M8AW.sbc1",
      platform: ["raspberry"],
      type: ["hexapod"],
    },
    {
      image: "Raspberry%20Pi/TonyPi_(1).png",
      name: "TonyPi",
      link: "https://item.jd.com/10138711291459.html?pcdk=fAvl2OSPeJAgNcsxo_3oqUBL16z-tekPiysEECkr0mE=.M8AW.sbc1",
      platform: ["raspberry"],
      type: ["humanoid"],
    },
    {
      image: "Raspberry%20Pi/TonyPi%20Pro_.png",
      name: "TonyPi Pro",
      link: "https://item.jd.com/10138712996727.html?pcdk=Ch81OjeVei9V7F3M6MjEbo8G2y67h8K8ies9T6Vat1U=.M8AW.sbc1",
      platform: ["raspberry"],
      type: ["humanoid"],
    },
    {
      image: "AI&ROS/ROSOrin_.png",
      name: "ROSOrin",
      link: "https://item.jd.com/10214539522732.html?pcdk=3IZ8MOjPfR5Mf3cLWClVWnqlvQL9ZVJouXy02b23pC0=.M8AW.sbc1",
      platform: ["ros", "raspberry", "jetson"],
      type: ["car"],
    },
    {
      image: "AI&ROS/ROSOrin%20Pro_.png",
      name: "ROSOrin Pro",
      link: "https://item.jd.com/10214533266948.html?pcdk=3IZ8MOjPfR5Mf3cLWClVWqo5s5eG49CMswfxWZOXU6c=.M8AW.sbc1",
      platform: ["ros", "raspberry", "jetson"],
      type: ["composite"],
    },
    {
      image: "Jetson/JetAcker_.png",
      name: "JetAcker",
      link: "https://item.jd.com/10165165053310.html?pcdk=eHa1I914xaqok0P3aDmkOzRDk_r2PhJ1LF7on8qQsq8=.M8AW.sbc1",
      platform: ["jetson", "raspberry", "ros"],
      type: ["car"],
    },
    {
      image: "Jetson/JetArm_.png",
      name: "JetArm",
      link: "https://item.jd.com/10140151296131.html?pcdk=UuYD8nDI4k_YaalpgrYuVAYG4U2lV18yvwsY1TI-yJw=.M8AW.sbc1",
      platform: ["jetson", "ros"],
      type: ["arm"],
    },
    {
      image: "Jetson/JetArm%20Pro_.png",
      name: "JetArm Pro",
      link: "http://item.jd.com/10161357494535.html?pcdk=42QqPZoQXB9dQT-5kQSzZwCOFjm9_IRlh-HBpFbMW-Q=.M8AW.sbc1",
      platform: ["jetson", "ros"],
      type: ["arm", "composite"],
    },

    {
      image: "Jetson/JetAuto_.png",
      name: "JetAuto",
      link: "http://item.jd.com/10203782850899.html?pcdk=k8rklLfw6JJ6Ul6hIa5bxAfv69037_oBG97Ah6o0OlI=.M8AW.sbc1",
      platform: ["jetson", "raspberry", "ros"],
      type: ["car"],
    },
    {
      image: "Jetson/JetAuto%20Pro_.png",
      name: "JetAuto Pro",
      link: "https://item.jd.com/10063385609058.html?pcdk=LFk94aNDFacWkuPcnVodK5p1-gZ65gFvBERGCr1DRnw=.M8AW.sbc1",
      platform: ["jetson", "raspberry", "ros"],
      type: ["composite", "car"],
    },
    {
      image: "https://store.hiwonder.com.cn/uploads/20260916/FnasOqaRgvhF3LceEv7ECaRit4m6/%E6%9C%AA%E6%A0%87%E9%A2%98-1.png",
      name: "JetHexa",
      link: "https://item.jd.com/10096464238295.html?pcdk=a_l3I5YCy_CasGHnbJJz-97RdM8TQsWnR_D4Zp_7wDE=.M8AW.sbc1",
      platform: ["jetson", "ros"],
      type: ["hexapod"],
    },
    // {
    //   image:
    //     "725/%E8%B5%9B%E4%BA%8B%E6%A0%87%E5%87%86%E7%89%88%E5%85%AD%E8%B6%B3.png",
    //   name: "Competition Standard Hexapod",
    //   link: "https://detail.tmall.com/item.htm?abbucket=1&id=1010538715072&mi_id=0000RcjpBIFQ8xr87ReWHZbPvSSH2eeTMQH14AX0RTpm3Mk&ns=1&priceTId=2150452817849712479395393e0f15&spm=a21n57.1.hoverItem.4&utparam=%7B%22aplus_abtest%22%3A%2248db2dc5be30f7e6588c28c7100d6759%22%7D&xxc=taobaoSearch",
    //   platform: ["esp32", "microbit"],
    //   type: ["hexapod"],
    // },
    // {
    //   image:
    //     "725/%E8%B5%9B%E4%BA%8B%E5%8A%A0%E5%BC%BA%E7%89%88%E5%85%AD%E8%B6%B3.png",
    //   name: "Competition Advanced Hexapod",
    //   link: "https://item.taobao.com/item.htm?abbucket=1&id=1010596247696&mi_id=0000TCS5RZcq2SgHZg_FyuangXi79FOTPzU6TlrhMHoDq3I&ns=1&priceTId=2150452817849712479395393e0f15&spm=a21n57.1.hoverItem.5&utparam=%7B%22aplus_abtest%22%3A%22c6e835fee6e7f38c3f5cb1f4b76cb756%22%7D&xxc=taobaoSearch",
    //   platform: ["esp32", "microbit"],
    //   type: ["hexapod"],
    // },
    {
      image: "Jetson/JetMax_2027.png",
      name: "JetMax",
      link: "https://item.jd.com/10072871003600.html?pcdk=B_Bb-qyDEmQe0fpQIllUUSRu7wbWy8WcileaNZSWDME=.M8AW.sbc1",
      platform: ["jetson", "ros"],
      type: ["arm"],
    },
    // {
    //   image: "Jetson/JetMax%20Pro_.png",
    //   name: "JetMax Pro",
    //   link: "#",
    //   platform: ["jetson"],
    //   type: ["arm"],
    // },
    {
      image: "Jetson/JetRover_-1.png",
      name: "JetRover",
      link: "http://item.jd.com/10203788001939.html?pcdk=7JkJSdw5Xllj1R6eAhblfXmcJGgZp1cHoTpclsiG9eQ=.M8AW.sbc1",
      platform: ["jetson", "raspberry", "ros"],
      type: ["composite"],
    },
    {
      image: "Jetson/JetTank_.png",
      name: "JetTank",
      link: "https://item.jd.com/10116113631103.html?pcdk=lwOfwDKbOiGhaMpvzqzMOJm9mlx2wWRxm76NdLjWSfE=.M8AW.sbc1",
      platform: ["jetson", "ros", "raspberry"],
      type: ["car"],
    },
    {
      image: "microbit%20&%20scratch/AiArm_.png",
      name: "AiArm",
      link: "#",
      platform: ["scratch"],
      type: ["arm"],
    },
    {
      image: "microbit%20&%20scratch/AiHand.png",
      name: "AiHand",
      link: "#",
      platform: ["microbit"],
      type: ["gripper"],
    },
    {
      image: "microbit%20&%20scratch/AiNova_.png",
      name: "AiNova",
      link: "https://item.jd.com/10054633502015.html?pcdk=7xfdFOVV8BSsbM6VzRI20w8w8q0odPCXZuWl9B7ZHtg=.M8AW.sbc1",
      platform: ["esp32", "scratch", "arduino"],
      type: ["car"],
    },

    {
      image: "728/DaDa_bit.png",
      name: "DaDa:bit",
      link: "https://item.jd.com/10221814429603.html?pcdk=-SFwXZRZ2DyymexN2mOUUyhabPRGQn7xnA8-HDW-p6I=.M8AW.sbc1",
      platform: ["microbit"],
      type: ["kit"],
    },
    {
      image: "microbit%20&%20scratch/DaDa_bit_.png",
      name: "DaDa:bit V2",
      link: "https://item.jd.com/54608268199.html?pcdk=wAviIO_QqUWc4HENjgYVAshZ5ODvMGRiRpBKoNQsWoM=.M8AW.sbc1",
      platform: ["microbit"],
      type: ["kit"],
    },
    {
      image: "microbit%20&%20scratch/DaDa_bit%20AI_.png",
      name: "DaDa:bit AI",
      link: "https://item.jd.com/10226409197059.html?pcdk=-SFwXZRZ2DyymexN2mOUUwp8UJrU1iktOgWzay-SVQs=.M8AW.sbc1",
      platform: ["microbit"],
      type: ["kit"],
    },

    {
      image: "microbit%20&%20scratch/DaDablock_.png",
      name: "DaDablock",
      link: "https://item.taobao.com/item.htm?id=1046678893531&mi_id=0000YhRywCEDKNTjxGlXxmD3TYpC44RFA-m8ZWR4e_FyPRE&ns=1&priceTId=214781f817854046041302436e1191&skuId=6071461273397&spm=a21n57.1.similarHoverItem.4&utparam=%7B%22aplus_abtest%22%3A%22929d1990d4d6ae9ef19d9ef1640f6b5f%22%7D&xxc=taobaoSearch",
      platform: ["esp32", "scratch"],
      type: ["kit"],
    },
    {
      image: "microbit%20&%20scratch/DaDablock%20Al_.png",
      name: "DaDablock Al",
      link: "https://detail.tmall.com/item.htm?id=1058948365827&mi_id=00001LvxC78IBBBNPJR7q0tlK6LmnnEh-cYsBE4zcJ23S2A&ns=1&priceTId=2147842b17854049146426734e0e52&skuId=6266738911083&spm=a21n57.1.similarHoverItem.6&utparam=%7B%22aplus_abtest%22%3A%2257228652778d443c07cabb59b76773b2%22%7D&xxc=taobaoSearch",
      platform: ["esp32", "scratch"],
      type: ["kit"],
    },
    {
      image: "https://store.hiwonder.com.cn/uploads/20260818/FsKEo5TEB64DoLieHreDyVznrOg2/%E7%99%BD%E5%BA%95%E5%9B%BE(1).jpg",
      name: "DaDablock AI Vision Kit",
      handle: "dadablock-ai-vision-kit",
      platform: ["scratch"],
      type: ["kit"],
    },
    // {
    //   image: "728/Mask%20Production%20Line.png",
    //   name: "Mask Production Line",
    //   link: "https://detail.tmall.com/item.htm?abbucket=1&id=641380003814&mi_id=00001yOrbhCbJlVGet0r-O3Lza2RDUP7xq6Erm1zFLGbjKo&ns=1&priceTId=2150452817849714623116288e0f15&skuId=4601605748153&spm=a21n57.1.hoverItem.1&utparam=%7B%22aplus_abtest%22%3A%223203d8f5ac22767ead4b3ad815e9aae8%22%7D&xxc=taobaoSearch",
    //   platform: ["microbit"],
    //   type: ["kit"],
    // },
    {
      image: "ESP32%20&%20Arduino/1030/MechDog.png",
      name: "MechDog",
      link: "https://item.jd.com/10109817060745.html",
      platform: ["esp32", "arduino", "microbit", "scratch"],
      type: ["quadruped"],
    },
    {
      image: "ESP32%20&%20Arduino/1030/MechDog%20Pro.png",
      name: "MechDog AI",
      handle: "mechdog-ai",
      platform: ["esp32", "arduino", "scratch"],
      type: ["quadruped"],
    },
    {
      image: "ESP32%20&%20Arduino/miniHexa_.png",
      name: "miniHexa",
      link: "https://item.jd.com/10199628080246.html?pcdk=VK6qDfb_2fMKYdO7RhYwUTayfFudjHQzzve4ty6B3zw=.M8AW.sbc1",
      platform: ["esp32", "arduino", "scratch"],
      type: ["hexapod"],
    },
    {
      image: "https://store.hiwonder.com.cn/uploads/20260820/Fjdz0gsMeAcuNc5QoOfT5LKgiZfY/1-2000x2000.png",
      name: "miniHexa Pro",
      handle: "minihexa-pro",
      platform: ["esp32", "arduino", "scratch"],
      type: ["hexapod"],
    },
    {
      image: "ESP32%20&%20Arduino/Tonybot_.png",
      name: "Tonybot",
      link: "https://item.jd.com/10020072669759.html?pcdk=fnqZubGfAmDXTw7LzdZD79XhFnc72JGkFdRCvjPm_OQ=.M8AW.sbc1",
      platform: ["esp32", "arduino", "scratch"],
      type: ["humanoid"],
    },
    {
      image: "microbit%20&%20scratch/Nexbit_.png",
      name: "Nexbit",
      link: "https://item.jd.com/10121305540027.html?pcdk=Jz383cpLEYF_DkWoS4KHnr0yVBTAizK1qTIAkLgLIPs=.M8AW.sbc1",
      platform: ["microbit"],
      type: ["car"],
    },
    {
      image: "https://store.hiwonder.com.cn/uploads/20260907/FlyalM9qiovjJe96IC_B7J0ibhm_/%E5%9B%BE%E7%89%87%2053@1x.png",
      name: "Nexbit AI",
      handle: "nexbit-ai",
      platform: ["microbit"],
      type: ["car"],
    },
    {
      image: "microbit%20&%20scratch/Qtruck_.png",
      name: "Qtruck",
      link: "https://item.jd.com/54520732665.html?pcdk=EsP_6fWrNR1aQBUWqV_dubU3AxeuY_2aOTNyh-S2z1w=.M8AW.sbc1",
      platform: ["microbit"],
      type: ["car"],
    },
    {
      image: "microbit%20&%20scratch/%E5%BE%AE%E5%9C%BA%E6%99%AF/5.jpg",
      name: "Waste Sorting Kit",
      link: "https://item.jd.com/10024764850622.html?pcdk=wFSdeIx7V4ZTff_ZZEjg__FIzbuP8uc0bUNXmuzLBRc=.M8AW.sbc1",
      platform: ["microbit"],
      type: ["scene"],
    },
    {
      image: "microbit%20&%20scratch/loT%20Smart%20House%20Kit_.png",
      name: "IoT Smart House Kit",
      handle: "iot-smart-house-kit",
      link: "/products/iot-smart-house-kit",
      platform: ["microbit"],
      type: ["kit"],
    },
    {
      image: "ESP32%20&%20Arduino/LeArm_.png",
      name: "LeArm",
      link: "https://item.jd.com/10154187876782.html?pcdk=oTKLWsJq2yOxCU4175BUT_4gjN86FgWRhFPTPidiQl0=.M8AW.sbc1",
      platform: ["esp32", "arduino"],
      type: ["arm"],
    },
    {
      image: "ESP32%20&%20Arduino/MaxArm_.png",
      name: "MaxArm",
      link: "https://item.jd.com/10065293765811.html?pcdk=h6CJcHEdqMR8eZ6ujOvttj0ZCbOcM4O6D98qStl2ADc=.M8AW.sbc1",
      platform: ["esp32", "arduino"],
      type: ["arm"],
    },
    {
      image: "ESP32%20&%20Arduino/NexArm%20LeRobot_.png",
      name: "NexArm LeRobot",
      link: "https://item.jd.com/10221641379881.html?pcdk=0Ve-X6wfrFCJn5A56nSDE5PCTvkOMGwuethwd07LQQ0=.M8AW.sbc1",
      platform: ["esp32"],
      type: ["arm"],
    },
    {
      image: "ESP32%20&%20Arduino/NexArm_.png",
      name: "NexArm",
      link: "https://item.jd.com/10221641379881.html?pcdk=wVzP48D3iaKMDjLpbX_q-eZf8iaEi6CL9wJaUQNdwPo=.M8AW.sbc1",
      platform: ["esp32", "ros", "arduino"],
      type: ["arm"],
    },
    // {
    //   image: "728/%E7%94%BB%E6%9D%BF%206.png",
    //   name: "Dual-Arm Production Line",
    //   link: "https://item.taobao.com/item.htm?id=1061449255100&mi_id=0000GQ3812MdW0JBe0si_c0SbYtQ_w9xSanPi4O070NV9DE&spm=a21xtw.29978518.0.0&xxc=shop&sku_properties=1627207%3A44230766952",
    //   platform: ["ros", "jetson"],
    //   type: ["arm"],
    // },
    {
      image: "ESP32%20&%20Arduino/SO-ARM101.png",
      name: "SO-ARM101",
      link: "https://item.jd.com/10191411661383.html?pcdk=sGgnfkaf18tkLNZnuSb34w3_RJo0Z2qPlIkM3fpG-7A=.M8AW.sbc1",
      platform: ["esp32"],
      type: ["arm"],
    },
    {
      image: "ESP32%20&%20Arduino/Spiderbot.png",
      name: "Spiderbot",
      link: "https://item.jd.com/72342590882.html?pcdk=qvLVLikwzwjzBTvrhvrzg4GqBTOBgMWc-0kgTVpRbTE=.M8AW.sbc1",
      platform: ["esp32", "arduino"],
      type: ["hexapod"],
    },
    // {
    //   image: "ESP32%20&%20Arduino/Tankbot_.png",
    //   name: "Tankbot",
    //   link: "https://item.jd.com/10204510519252.html?pcdk=hZatYKlXmNG_es_oLP1NFQ41en7QR7YTcix9QvnImjc=.M8AW.sbc1",
    //   platform: ["esp32"],
    //   type: ["composite"],
    // },
    {
      image: "ESP32%20&%20Arduino/Untitled2_.png",
      name: "Tankbot",
      link: "https://item.jd.com/10204510519252.html?pcdk=hZatYKlXmNG_es_oLP1NFQ41en7QR7YTcix9QvnImjc=.M8AW.sbc1",
      platform: ["esp32", "arduino"],
      type: ["composite"],
    },
    {
      image: "ESP32%20&%20Arduino/miniArm_.png",
      name: "miniArm",
      link: "https://item.jd.com/10105338956784.html?pcdk=dc6rvKVohRNkN-ymxSnooJPCDIN4wadJHAsKrwFKLF4=.M8AW.sbc1",
      platform: ["esp32", "arduino"],
      type: ["arm"],
    },
    {
      image: "ESP32%20&%20Arduino/miniAuto_.png",
      name: "miniAuto",
      link: "https://item.jd.com/10198275119127.html?pcdk=-vtOHSerCkBcSdBjAN2cF1grZTdBZom0IsJRl4-b62YhmdXp0NsSbLvF5R-6B_BK.rQ4a.tlbT#switch-sku",
      platform: ["esp32", "arduino"],
      type: ["car"],
    },
    {
      image: "ESP32%20&%20Arduino/miniAuto%20Pro_.png",
      name: "miniAuto Pro",
      handle: "miniauto-pro",
      platform: ["esp32", "arduino", "scratch"],
      type: ["car"],
    },

    {
      image: "ESP32%20&%20Arduino/uHand.png",
      name: "uHand",
      link: "https://detail.tmall.com/item.htm?abbucket=8&id=873318999628&mi_id=0000vswy3vREH2WarmYiYzpzA7tx16P9RHfel7ZNZ3yhPeE&rn=440f49d431e17ac9b2ebe913966effe5&spm=a1z10.3-b-s.w4011-21879442389.39.5d92f4dbDjH1wm",
      platform: ["arduino"],
      type: ["gripper"],
    },
    {
      image: "ESP32%20&%20Arduino/uHand%20UNO_.png",
      name: "uHand UNO",
      link: "https://item.jd.com/10095747136000.html?pcdk=mzcCEnR8zCYGlJUXSxKPcuGMzKfCv2d0L3Jy_OVG2Iw=.M8AW.sbc1",
      platform: ["arduino"],
      type: ["gripper"],
    },
    {
      image: "ESP32%20&%20Arduino/uHand2.0-V1.png",
      name: "uHand2.0",
      link: "https://item.jd.com/10086097222653.html?pcdk=t_hYeIRijPtNoBvUjT5Q-y5hfPyThxAF3oLFXYlqX6s=.M8AW.sbc1",
      platform: ["arduino"],
      type: ["gripper"],
    },
    {
      image: "725/uHandbit.jpg",
      name: "uHandbit",
      link: "https://detail.tmall.com/item.htm?abbucket=1&id=598857328368&mi_id=0000mru_AAgi1iXGa6QC29IT-knEXDdYspCXJh8ZmmW3QoA&ns=1&priceTId=2147802217849709835636464e0e67&skuId=4178114792796&spm=a21n57.1.hoverItem.3&utparam=%7B%22aplus_abtest%22%3A%229bded21af11977be17bc22d7d0c9eee1%22%7D&xxc=taobaoSearch",
      platform: ["microbit"],
      type: ["gripper"],
    },
    {
      image: "728/xArm%20Ai.png",
      name: "xArm AI",
      link: "https://item.jd.com/10139693337933.html?pcdk=KATKpi2AUoPxytktAAdpKTnz_dIrARuaZopaDJYAjtY=.M8AW.sbc1",
      platform: ["esp32", "scratch", "arduino"],
      type: ["arm"],
    },
    {
      image: "ESP32%20&%20Arduino/xArm1S.png",
      name: "xArm1S",
      link: "https://item.jd.com/54291564929.html?pcdk=ZdeiubK60QOMiN5hgowG0vIwAzsOWynq8qLU58JbNUg=.M8AW.sbc1",
      platform: ["other"],
      type: ["arm"],
    },
    {
      image: "ESP32%20&%20Arduino/xArm2.0.png",
      name: "xArm2.0",
      link: "https://item.jd.com/64930241698.html?pcdk=IM-JsNo3hwsgWhaO-d5jZPE7q36XMgScGVGA48qsD1E=.M8AW.sbc1",
      platform: ["esp32", "scratch"],
      type: ["arm"],
    },
    {
      image: "ESP32%20&%20Arduino/xArm%E6%A0%87%E5%87%86%E7%89%88.png",
      name: "xArm-ESP32",
      link: "https://item.jd.com/10023606136661.html?pcdk=cVivyXrAFi4tmFjmtbeL64i_nWKvYx1uUM1qjfpe3fA=.M8AW.sbc1",
      platform: ["esp32"],
      type: ["arm"],
    },
    // {
    //   image: "ESP32%20&%20Arduino/%E5%B7%AE%E9%80%9F%E5%B0%8F%E8%BD%A6_.png",
    //   name: "Differential Drive Car",
    //   link: "https://item.jd.com/10146528336584.html?pcdk=Ul3W4OZznOyjhzd6hzZwWUcCTVchzN-TbakTqMaYD00=.M8AW.sbc1",
    //   platform: ["esp32"],
    //   type: ["car"],
    // },
  ];

  var productHandleOverrides = {
    "DaDa:bit V2": "dada-bit-v2",
    "DaDa:bit AI": "dadabit-ai",
    "DaDablock Al": "dadablock-ai",
    "LanderPi Tracked Chassis": "landerpi",
    MentorPi: "mentorpi-m1-monocular-camera-version",
    Qtruck: "qtruck-programmable-educational-robot",
    "Waste Sorting Kit": "waste-sorting-robot",
    LeArm: "learm-ai",
    "NexArm LeRobot": "nexarm6-axis",
    "SO-ARM101": "lerobot-so-101",
    xArm1S: "xarm-1s",
    "xArm Standard Edition": "xarm-unowith-sensor",
  };

  function toShopifyHandle(value) {
    return String(value || "")
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[’']/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  global.getProductSelectionProductUrl = function (product) {
    var productName = product && product.name ? product.name : "";
    var handle = product && product.handle ? product.handle : productHandleOverrides[productName];
    handle = toShopifyHandle(handle || productName);
    if (!handle) {
      return "#";
    }

    var shopifyRoot = global.Shopify && global.Shopify.routes ? global.Shopify.routes.root : "/";
    return String(shopifyRoot || "/").replace(/\/?$/, "/") + "products/" + encodeURIComponent(handle);
  };

  var shopifyProducts = Array.isArray(global.PRODUCT_SELECTION_SHOPIFY_PRODUCTS)
    ? global.PRODUCT_SELECTION_SHOPIFY_PRODUCTS
    : [];

  shopifyProducts.forEach(function (shopifyProduct) {
    var shopifyProductUrl = global.getProductSelectionProductUrl(shopifyProduct);
    var existingIndex = global.PRODUCT_SELECTION_PRODUCTS.findIndex(function (product) {
      return global.getProductSelectionProductUrl(product) === shopifyProductUrl;
    });

    if (existingIndex === -1) {
      global.PRODUCT_SELECTION_PRODUCTS.push(shopifyProduct);
      return;
    }

    global.PRODUCT_SELECTION_PRODUCTS[existingIndex] = Object.assign(
      {},
      global.PRODUCT_SELECTION_PRODUCTS[existingIndex],
      shopifyProduct,
    );
  });

  var mentorPiHandleOrder = [
    "mentorpi-a1",
    "mentorpi-a1-monocular-camera-version",
    "mentorpi-m1",
    "mentorpi-m1-monocular-camera-version",
    "mentorpi-t1",
  ];
  var mentorPiProducts = [];
  var firstMentorPiIndex = -1;

  for (var productIndex = global.PRODUCT_SELECTION_PRODUCTS.length - 1; productIndex >= 0; productIndex -= 1) {
    var candidateProduct = global.PRODUCT_SELECTION_PRODUCTS[productIndex];
    var candidateName = candidateProduct && candidateProduct.name ? candidateProduct.name : "";
    var candidateHandle = toShopifyHandle(
      (candidateProduct && candidateProduct.handle) || productHandleOverrides[candidateName] || candidateName,
    );

    if (candidateHandle === "mentorpi" || candidateHandle.indexOf("mentorpi-") === 0) {
      firstMentorPiIndex = productIndex;
      mentorPiProducts.unshift(global.PRODUCT_SELECTION_PRODUCTS.splice(productIndex, 1)[0]);
    }
  }

  mentorPiProducts.sort(function (firstProduct, secondProduct) {
    var firstName = firstProduct && firstProduct.name ? firstProduct.name : "";
    var secondName = secondProduct && secondProduct.name ? secondProduct.name : "";
    var firstHandle = toShopifyHandle(
      (firstProduct && firstProduct.handle) || productHandleOverrides[firstName] || firstName,
    );
    var secondHandle = toShopifyHandle(
      (secondProduct && secondProduct.handle) || productHandleOverrides[secondName] || secondName,
    );
    var firstOrder = mentorPiHandleOrder.indexOf(firstHandle);
    var secondOrder = mentorPiHandleOrder.indexOf(secondHandle);

    firstOrder = firstOrder === -1 ? mentorPiHandleOrder.length : firstOrder;
    secondOrder = secondOrder === -1 ? mentorPiHandleOrder.length : secondOrder;
    return firstOrder - secondOrder;
  });

  if (firstMentorPiIndex !== -1 && mentorPiProducts.length) {
    global.PRODUCT_SELECTION_PRODUCTS.splice.apply(
      global.PRODUCT_SELECTION_PRODUCTS,
      [firstMentorPiIndex, 0].concat(mentorPiProducts),
    );
  }
})(window);
